package com.evoapps.evoshift.ui.util

import androidx.compose.runtime.Composable
import com.evoapps.evoshift.domain.schedule.LabourWarning
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.labour_warning_daily_norm
import evoshift.composeapp.generated.resources.labour_warning_daily_rest
import evoshift.composeapp.generated.resources.labour_warning_overtime
import evoshift.composeapp.generated.resources.labour_warning_weekly_average
import evoshift.composeapp.generated.resources.labour_warning_weekly_rest
import kotlinx.datetime.LocalDate
import org.jetbrains.compose.resources.stringResource
import kotlin.math.roundToInt

/*
 * SH-112: the labour code's warnings in words. The domain (LabourCodeCheck) gives the facts:
 * hours, dates and the limit; these sentences put them in the user's language.
 */

/** Hours as the warnings show them: whole ones without decimals ("32"), else one ("10.5"). */
fun labourHours(hours: Double): String {
    val tenths = (hours * 10).roundToInt()
    return if (tenths % 10 == 0) "${tenths / 10}" else "${tenths / 10}.${tenths % 10}"
}

/** "Only 8 h of rest in the 24 h from 9 November (11 h required)" and the like. */
@Composable
fun LabourWarning.text(): String = when (this) {
    is LabourWarning.ShortDailyRest ->
        stringResource(Res.string.labour_warning_daily_rest, labourHours(restHours), dayAndMonth(LocalDate.parse(date)))
    is LabourWarning.ShortWeeklyRest ->
        stringResource(Res.string.labour_warning_weekly_rest, labourHours(restHours), dayAndMonth(LocalDate.parse(weekStart)))
    is LabourWarning.OverDailyNorm ->
        stringResource(Res.string.labour_warning_daily_norm, labourHours(hours), dayAndMonth(LocalDate.parse(date)), labourHours(normHours))
    is LabourWarning.OverWeeklyAverage ->
        stringResource(Res.string.labour_warning_weekly_average, labourHours(averageHours))
    is LabourWarning.OvertimeOverCap ->
        stringResource(Res.string.labour_warning_overtime, labourHours(overtimeHours), labourHours(capHours))
}
